module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/new1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fnew1.png
// module id = mGZq
// module chunks = 93